import {ApplicationRef, ComponentRef, createComponent, EnvironmentInjector, Injectable} from '@angular/core';
import {RefreshAppDialogComponent} from './refresh-app-dialog.component';

@Injectable({providedIn: 'root'})
export class RefreshAppDialogService {
    private componentRef: ComponentRef<RefreshAppDialogComponent> | null = null;

    constructor(private readonly appRef: ApplicationRef, private readonly injector: EnvironmentInjector) {
    }

    show(message: string, title = 'Session Expired'): void {
        if (this.componentRef) {
            this.componentRef.instance.message = message;
            this.componentRef.instance.title = title;
            return;
        }

        this.componentRef = createComponent(RefreshAppDialogComponent, {
            environmentInjector: this.injector
        });
        this.componentRef.instance.title = title;
        this.componentRef.instance.message = message;
        this.componentRef.instance.refresh.subscribe(() => {
            this.dismiss();
            location.reload();
        });

        this.appRef.attachView(this.componentRef.hostView);
        const rootNode = (this.componentRef.hostView as any).rootNodes?.[0] as HTMLElement | undefined;
        if (rootNode) {
            document.body.appendChild(rootNode);
        }
    }

    private dismiss(): void {
        if (!this.componentRef) return;
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.componentRef = null;
    }
}
